export default{sideNavigationItem:"w_C6",isCurrent:"w_C7",leading:"w_C8"};
